const create = config => {
  const { root, imageResizeRoot = root } = config;

  const supportsWebp = (() => {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
      return elem.toDataURL('image/webp').includes('data:image/webp');
    }
    return false;
  })();

  const resize = (
    url = {},
    { webp = supportsWebp, mediaReady = true, ...options } = {}
  ) => {
    const imagePath = (url && url.s3_web_path) || (url && url.url) || url;
    const webpFormat = webp ? { format: 'webp' } : {};

    if (!imagePath || !mediaReady) return '';

    const defaults = {
      fit: 'inside',
      quality: 60,
      withoutEnlargement: true,
      ...webpFormat,
      ...options,
    };

    const params = Object.keys(defaults)
      .map(key => `${key}_${defaults[key]}`)
      .join(',');

    return `${imageResizeRoot}/${params}/${imagePath}`;
  };

  return {
    resize,
  };
};

export { create };
